import { trendingConstants } from '../_constants';

//-- get the list of terms
export function getTrendingList(state = {}, action) {
  switch (action.type) {
    case trendingConstants.TRENDING_LIST_REQUEST:
      return {
        getTrendingList: false
      };

    case trendingConstants.TRENDING_LIST_SUCCESS:
      //console.log("REDUCER ", action);
      return { isGetAdvertismentList: true, getTrendingList: action.successAction };

    case trendingConstants.TRENDING_LIST_FAILURE:
      return {
        getTrendingList: false,
      };

    case trendingConstants.TRENDING_SEARCH_REQUEST:
      return { isGetAdvertismentList: true, getTrendingList: action.successAction.data };

    default:
      return state
  }
}


export function deleteTrending(state = {}, action) {
  switch (action.type) {
    case trendingConstants.TRENDING_DELETE_REQUEST:
      return {
        deleteTrending: false
      };

    case trendingConstants.TRENDING_DELETE_SUCCESS:
      return { deleteTrending: action.successAction };

    case trendingConstants.TRENDING_DELETE_FAILURE:
      return {
        deleteTrending: false,
      };

    default:
      return state
  }
}